/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { PrueflaufAufgabeBemerkung } from '../model/prueflaufAufgabeBemerkung';
// @ts-ignore
import { PrueflaufBemerkung } from '../model/prueflaufBemerkung';
// @ts-ignore
import { PrueflaufBerechtigung } from '../model/prueflaufBerechtigung';
// @ts-ignore
import { PrueflaufDetail } from '../model/prueflaufDetail';
// @ts-ignore
import { PrueflaufRequest } from '../model/prueflaufRequest';
// @ts-ignore
import { PrueflaufStatusRequest } from '../model/prueflaufStatusRequest';
// @ts-ignore
import { VeranstaltungPrueflaufStatus } from '../model/veranstaltungPrueflaufStatus';
// @ts-ignore
import { VeranstaltungPruefplanRollenListe } from '../model/veranstaltungPruefplanRollenListe';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PrueflaufQueryService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * GetPrueflaufAufgabeBemerkung
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/prueflauf/v1/{prueflauf_id}/aufgaben/{aufgabe_id}/bemerkung
     * @param prueflaufId 
     * @param aufgabeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPrueflaufAufgabeBemerkung(prueflaufId: string, aufgabeId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufAufgabeBemerkung>;
    public getPrueflaufAufgabeBemerkung(prueflaufId: string, aufgabeId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufAufgabeBemerkung>>;
    public getPrueflaufAufgabeBemerkung(prueflaufId: string, aufgabeId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufAufgabeBemerkung>>;
    public getPrueflaufAufgabeBemerkung(prueflaufId: string, aufgabeId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufId === null || prueflaufId === undefined) {
            throw new Error('Required parameter prueflaufId was null or undefined when calling getPrueflaufAufgabeBemerkung.');
        }
        if (aufgabeId === null || aufgabeId === undefined) {
            throw new Error('Required parameter aufgabeId was null or undefined when calling getPrueflaufAufgabeBemerkung.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/prueflauf/v1/${this.configuration.encodeParam({name: "prueflaufId", value: prueflaufId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aufgaben/${this.configuration.encodeParam({name: "aufgabeId", value: aufgabeId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bemerkung`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufAufgabeBemerkung>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPrueflaufAufgabeBild
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/prueflauf/v1/{prueflauf_id}/aufgaben/{aufgabe_id}/bild
     * @param prueflaufId 
     * @param aufgabeId 
     * @param bildId 
     * @param width 
     * @param height 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPrueflaufAufgabeBild(prueflaufId: string, aufgabeId: string, bildId?: string, width?: number, height?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getPrueflaufAufgabeBild(prueflaufId: string, aufgabeId: string, bildId?: string, width?: number, height?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getPrueflaufAufgabeBild(prueflaufId: string, aufgabeId: string, bildId?: string, width?: number, height?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getPrueflaufAufgabeBild(prueflaufId: string, aufgabeId: string, bildId?: string, width?: number, height?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufId === null || prueflaufId === undefined) {
            throw new Error('Required parameter prueflaufId was null or undefined when calling getPrueflaufAufgabeBild.');
        }
        if (aufgabeId === null || aufgabeId === undefined) {
            throw new Error('Required parameter aufgabeId was null or undefined when calling getPrueflaufAufgabeBild.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'bild_id',
            <any>bildId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'width',
            <any>width,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'height',
            <any>height,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/qs/query/prueflauf/v1/${this.configuration.encodeParam({name: "prueflaufId", value: prueflaufId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/aufgaben/${this.configuration.encodeParam({name: "aufgabeId", value: aufgabeId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bild`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPrueflaufBemerkung
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/prueflauf/v1/{prueflauf_id}/bemerkung
     * @param prueflaufId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPrueflaufBemerkung(prueflaufId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufBemerkung>;
    public getPrueflaufBemerkung(prueflaufId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufBemerkung>>;
    public getPrueflaufBemerkung(prueflaufId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufBemerkung>>;
    public getPrueflaufBemerkung(prueflaufId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufId === null || prueflaufId === undefined) {
            throw new Error('Required parameter prueflaufId was null or undefined when calling getPrueflaufBemerkung.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/prueflauf/v1/${this.configuration.encodeParam({name: "prueflaufId", value: prueflaufId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bemerkung`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufBemerkung>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPrueflaufBerechtigung
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint post /api/qs/query/prueflauf/v1/berechtigung/prueflauf
     * @param prueflaufStatusRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPrueflaufBerechtigung(prueflaufStatusRequest: PrueflaufStatusRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufBerechtigung>;
    public getPrueflaufBerechtigung(prueflaufStatusRequest: PrueflaufStatusRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufBerechtigung>>;
    public getPrueflaufBerechtigung(prueflaufStatusRequest: PrueflaufStatusRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufBerechtigung>>;
    public getPrueflaufBerechtigung(prueflaufStatusRequest: PrueflaufStatusRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufStatusRequest === null || prueflaufStatusRequest === undefined) {
            throw new Error('Required parameter prueflaufStatusRequest was null or undefined when calling getPrueflaufBerechtigung.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/prueflauf/v1/berechtigung/prueflauf`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufBerechtigung>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufStatusRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetPrueflaufBild
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/prueflauf/v1/{prueflauf_id}/bild
     * @param prueflaufId 
     * @param bildId 
     * @param width 
     * @param height 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPrueflaufBild(prueflaufId: string, bildId?: string, width?: number, height?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getPrueflaufBild(prueflaufId: string, bildId?: string, width?: number, height?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getPrueflaufBild(prueflaufId: string, bildId?: string, width?: number, height?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getPrueflaufBild(prueflaufId: string, bildId?: string, width?: number, height?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufId === null || prueflaufId === undefined) {
            throw new Error('Required parameter prueflaufId was null or undefined when calling getPrueflaufBild.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'bild_id',
            <any>bildId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'width',
            <any>width,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'height',
            <any>height,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/qs/query/prueflauf/v1/${this.configuration.encodeParam({name: "prueflaufId", value: prueflaufId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bild`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetVeranstaltungPrueflauf
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint post /api/qs/query/prueflauf/v1/veranstaltungen/prueflauf
     * @param prueflaufRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVeranstaltungPrueflauf(prueflaufRequest: PrueflaufRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufDetail>;
    public getVeranstaltungPrueflauf(prueflaufRequest: PrueflaufRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufDetail>>;
    public getVeranstaltungPrueflauf(prueflaufRequest: PrueflaufRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufDetail>>;
    public getVeranstaltungPrueflauf(prueflaufRequest: PrueflaufRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufRequest === null || prueflaufRequest === undefined) {
            throw new Error('Required parameter prueflaufRequest was null or undefined when calling getVeranstaltungPrueflauf.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/prueflauf/v1/veranstaltungen/prueflauf`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufDetail>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetVeranstaltungPrueflaufStatus
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint post /api/qs/query/prueflauf/v1/veranstaltung/prueflaufstatus
     * @param prueflaufStatusRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVeranstaltungPrueflaufStatus(prueflaufStatusRequest: PrueflaufStatusRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungPrueflaufStatus>;
    public getVeranstaltungPrueflaufStatus(prueflaufStatusRequest: PrueflaufStatusRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungPrueflaufStatus>>;
    public getVeranstaltungPrueflaufStatus(prueflaufStatusRequest: PrueflaufStatusRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungPrueflaufStatus>>;
    public getVeranstaltungPrueflaufStatus(prueflaufStatusRequest: PrueflaufStatusRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufStatusRequest === null || prueflaufStatusRequest === undefined) {
            throw new Error('Required parameter prueflaufStatusRequest was null or undefined when calling getVeranstaltungPrueflaufStatus.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/prueflauf/v1/veranstaltung/prueflaufstatus`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungPrueflaufStatus>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufStatusRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetVeranstaltungPruefplanRollenListe
     * ORGA App Zugriff: * QsChecks - Zugriff  | Pruefer | Controller  Problem Types: * KeinZugriff: (QsChecksKeinZugriff) * ModulNichtAktiv: (ModulNichtAktiv) * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) 
     * @endpoint get /api/qs/query/prueflauf/v1/veranstaltungen/{veranstaltung_id}/pruefplanrollenliste
     * @param veranstaltungId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getVeranstaltungPruefplanRollenListe(veranstaltungId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VeranstaltungPruefplanRollenListe>;
    public getVeranstaltungPruefplanRollenListe(veranstaltungId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VeranstaltungPruefplanRollenListe>>;
    public getVeranstaltungPruefplanRollenListe(veranstaltungId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VeranstaltungPruefplanRollenListe>>;
    public getVeranstaltungPruefplanRollenListe(veranstaltungId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (veranstaltungId === null || veranstaltungId === undefined) {
            throw new Error('Required parameter veranstaltungId was null or undefined when calling getVeranstaltungPruefplanRollenListe.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/query/prueflauf/v1/veranstaltungen/${this.configuration.encodeParam({name: "veranstaltungId", value: veranstaltungId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pruefplanrollenliste`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VeranstaltungPruefplanRollenListe>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
